import { useSelector } from 'react-redux';
import type { LocationState } from 'redux-first-router';
import { ROUTE_NARRATIVE } from '@/constants/routes';
import WatchlistAddRemoveCompanyToggle from '@/components/WatchlistAddRemoveCompanyToggle';

import { WatchlistButtonWrapper } from './styled';

interface Props {
  companyId: string;
  tickerSymbol: string;
}

export const useShouldShowAddWatchlistButton = () => {
  const isNarrativeRoute = useSelector<{ location: LocationState }>((state) => {
    return state.location.type === ROUTE_NARRATIVE;
  });

  return isNarrativeRoute;
};

export const AddWatchlistButton = ({ companyId, tickerSymbol }: Props) => {
  return (
    <WatchlistButtonWrapper>
      <WatchlistAddRemoveCompanyToggle
        styleType="loudLarge"
        companyId={companyId}
        tickerSymbol={tickerSymbol}
        display="block"
        alignIcon={undefined}
      />
    </WatchlistButtonWrapper>
  );
};
